// extracted by mini-css-extract-plugin
module.exports = {"bookFragment":"BookFragmentView__bookFragment","breadcrumbs":"BookFragmentView__breadcrumbs","bookText":"BookFragmentView__bookText"};